var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86193 0.861886C6.6016 1.12224 6.6016 1.54435 6.86193 1.8047L7.7298 2.6726C4.54153 2.81389 2 5.44345 2 8.66663C2 11.9804 4.68627 14.6666 8 14.6666C11.3137 14.6666 14 11.9804 14 8.66663C14 8.29843 13.7015 7.99996 13.3333 7.99996C12.9651 7.99996 12.6667 8.29843 12.6667 8.66663C12.6667 11.244 10.5773 13.3333 8 13.3333C5.42267 13.3333 3.33333 11.244 3.33333 8.66663C3.33333 6.18489 5.27053 4.15562 7.71533 4.0085L6.86193 4.86189C6.6016 5.12224 6.6016 5.54435 6.86193 5.8047C7.12227 6.06505 7.5444 6.06505 7.80473 5.8047L9.80474 3.8047C9.92976 3.67967 10 3.51011 10 3.33329C10 3.15648 9.92976 2.98691 9.80474 2.86189L7.80473 0.861886C7.5444 0.601539 7.12227 0.601539 6.86193 0.861886Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.3af98edf7abc37ca187466283a78ce05.svg";
export { ForwardRef as ReactComponent };